__turbopack_context__.v({
  "accordionBody": "Accordion-module-scss-module__q9udIG__accordionBody",
  "accordionBodyWrapper": "Accordion-module-scss-module__q9udIG__accordionBodyWrapper",
  "accordionItem": "Accordion-module-scss-module__q9udIG__accordionItem",
  "accordionItemHeader": "Accordion-module-scss-module__q9udIG__accordionItemHeader",
  "accordionItemWrapper": "Accordion-module-scss-module__q9udIG__accordionItemWrapper",
  "buttonIcon": "Accordion-module-scss-module__q9udIG__buttonIcon",
  "headline": "Accordion-module-scss-module__q9udIG__headline",
  "open": "Accordion-module-scss-module__q9udIG__open",
  "stack-module-0": "Accordion-module-scss-module__q9udIG__stack-module-0",
  "stack-module-1": "Accordion-module-scss-module__q9udIG__stack-module-1",
  "stack-module-10": "Accordion-module-scss-module__q9udIG__stack-module-10",
  "stack-module-11": "Accordion-module-scss-module__q9udIG__stack-module-11",
  "stack-module-12": "Accordion-module-scss-module__q9udIG__stack-module-12",
  "stack-module-13": "Accordion-module-scss-module__q9udIG__stack-module-13",
  "stack-module-14": "Accordion-module-scss-module__q9udIG__stack-module-14",
  "stack-module-15": "Accordion-module-scss-module__q9udIG__stack-module-15",
  "stack-module-16": "Accordion-module-scss-module__q9udIG__stack-module-16",
  "stack-module-17": "Accordion-module-scss-module__q9udIG__stack-module-17",
  "stack-module-18": "Accordion-module-scss-module__q9udIG__stack-module-18",
  "stack-module-19": "Accordion-module-scss-module__q9udIG__stack-module-19",
  "stack-module-2": "Accordion-module-scss-module__q9udIG__stack-module-2",
  "stack-module-20": "Accordion-module-scss-module__q9udIG__stack-module-20",
  "stack-module-3": "Accordion-module-scss-module__q9udIG__stack-module-3",
  "stack-module-4": "Accordion-module-scss-module__q9udIG__stack-module-4",
  "stack-module-5": "Accordion-module-scss-module__q9udIG__stack-module-5",
  "stack-module-6": "Accordion-module-scss-module__q9udIG__stack-module-6",
  "stack-module-7": "Accordion-module-scss-module__q9udIG__stack-module-7",
  "stack-module-8": "Accordion-module-scss-module__q9udIG__stack-module-8",
  "stack-module-9": "Accordion-module-scss-module__q9udIG__stack-module-9",
  "z-base": "Accordion-module-scss-module__q9udIG__z-base",
  "z-content": "Accordion-module-scss-module__q9udIG__z-content",
  "z-footer": "Accordion-module-scss-module__q9udIG__z-footer",
  "z-header": "Accordion-module-scss-module__q9udIG__z-header",
  "z-hero": "Accordion-module-scss-module__q9udIG__z-hero",
  "z-logo": "Accordion-module-scss-module__q9udIG__z-logo",
  "z-logo-effect": "Accordion-module-scss-module__q9udIG__z-logo-effect",
  "z-navigation": "Accordion-module-scss-module__q9udIG__z-navigation",
  "z-sub": "Accordion-module-scss-module__q9udIG__z-sub",
});
